const router = [
  {
    path: '/iot',
    name: 'iot',
    props: true,
    component: () => import('@/views/setting/iot/Device.vue'),
    meta: {
      title: 'IOT',
      hasBack: false,
      activeMenu: '/iot'
    }
  },
  // 设备详情
  {
    name: 'iotDetail',
    path: '/iot/deviceDetail',
    component: () => import('@/views/setting/iot/DeviceDetail.vue'),
    meta: {
      title: '查看',
      activeMenu: '/iot'
    }
  },
  // 设备历史数据-土壤监测
  {
    name: 'deviceSoilHistory',
    path: '/iot/deviceSoilHistory:deviceNumber',
    component: () => import('@/views/setting/iot/SoilHistory.vue'),
    meta: {
      title: '历史数据',
      activeMenu: '/iot'
    }
  },
  // 设备历史数据-水质监测
  {
    name: 'deviceWaterHistory',
    path: '/iot/deviceWaterHistory:deviceNumber',
    component: () => import('@/views/setting/iot/WaterHistory.vue'),
    meta: {
      title: '历史数据',
      activeMenu: '/iot'
    }
  },
  // 设备历史数据-环境监测
  {
    name: 'deviceWeatherHistory',
    path: '/iot/deviceWeatherHistory:deviceNumber',
    component: () => import('@/views/setting/iot/WeatherHistory.vue'),
    meta: {
      title: '历史数据',
      activeMenu: '/iot'
    }
  },
  // 设备历史数据-智慧虫情
  {
    name: 'deviceInsectHistory',
    path: '/iot/deviceInsectHistory:deviceNumber',
    component: () => import('@/views/setting/iot/InsectHistory.vue'),
    meta: {
      title: '历史数据',
      activeMenu: '/iot'
    }
  },
  // 设备历史数据-智慧水表
  {
    name: 'waterInfoHistory',
    path: '/iot/deviceWaterInfoHistory:deviceNumber',
    component: () => import('@/views/setting/iot/WaterInfoHistory.vue'),
    meta: {
      title: '历史数据',
      activeMenu: '/iot'
    }
  },
  // 设备历史数据-智慧·表
  {
    name: 'electronicHistory',
    path: '/iot/deviceElectronicHistory:deviceNumber',
    component: () => import('@/views/setting/iot/ElectronicHistory.vue'),
    meta: {
      title: '历史数据',
      activeMenu: '/iot'
    }
  },
  // 设备历史数据-垃圾桶
  {
    name: 'trashHistory',
    path: '/iot/devicetrashHistory:deviceNumber',
    component: () => import('@/views/setting/iot/TranshHistory.vue'),
    meta: {
      title: '历史数据',
      activeMenu: '/iot'
    }
  },
  // 设备历史数据-割草
  {
    name: 'MowingHistory',
    path: '/iot/devicetrashHistory:deviceNumber',
    component: () => import('@/views/setting/iot/MowingHistory.vue'),
    meta: {
      title: '历史数据',
      activeMenu: '/iot'
    }
  },
  // 设备历史数据-电磁阀
  {
    name: 'IrrigationHistory',
    path: '/iot/devicetrashHistory:deviceNumber',
    component: () => import('@/views/setting/iot/IrrigationHistory.vue'),
    meta: {
      title: '历史数据',
      activeMenu: '/iot'
    }
  },
  // 设备历史数据-智慧工牌
  {
    name: 'deviceWordCardHistory',
    path: '/iot/WordCardHistory:deviceNumber',
    component: () => import('@/views/setting/iot/WordCardHistory.vue'),
    meta: {
      title: '历史数据',
      activeMenu: '/iot'
    }
  },
  // 设备历史数据-智慧手环
  {
    name: 'deviceBraceletHistory',
    path: '/iot/BraceletHistory:deviceNumber',
    component: () => import('@/views/setting/iot/BraceletHistory.vue'),
    meta: {
      title: '历史数据',
      activeMenu: '/iot'
    }
  },
  // 设备历史数据-流速监测
  {
    name: 'deviceSpeedHistory',
    path: '/iot/SpeedHistory:deviceNumber',
    component: () => import('@/views/setting/iot/SpeedHistory.vue'),
    meta: {
      title: '历史数据',
      activeMenu: '/iot'
    }
  },
  // 设备历史数据-雾森监测
  {
    name: 'mistForestHistory',
    path: '/iot/mistForestHistory:deviceNumber',
    component: () => import('@/views/setting/iot/mistForestHistory.vue'),
    meta: {
      title: '历史数据',
      activeMenu: '/iot'
    }
  }
]

export default router
